module.exports = __webpack_public_path__ + "static/media/slow-creative-arrow-up.4bbcec57.svg";